import { addEventListeners, removeEventListeners, querySelectorLast } from "../utils/dom";

/**
 * Valdiation form custom element
 * jQuery validate and validate unobtrusive handles the actual validation logic.
 */
export default class ValidationForm extends HTMLFormElement {

    formGroupClassName = "form-group";
    formGroupInvalidClassName = "invalid-group";
    handleEnterPressSelector = "input:not([type=button]):not([type=submit]):not(button)"

    connectedCallback() {

        import(/* webpackChunkName: "validation" */ '../validation/validation').then(module => {
            this.initForm();
            $(this).on("invalid-form.validate", this.invalidHandler);
            addEventListeners(this.querySelectorAll(this.handleEnterPressSelector), "keypress", this.handleEnterPress);
        });

        import(/* webpackChunkName: "umbracoforms" */ '../umbraco/umbracoforms').then(module => {
            
        });

    }

    disconnectedCallback() {
        $(this).off("invalid-form.validate", this.invalidHandler);
        removeEventListeners(this.querySelectorAll(this.handleEnterPressSelector), "keypress", this.handleEnterPress);
    }

    initForm() {

        this.validationSummary?.setAttribute("tabindex", "-1");

        // Add pattern attribute if missing
        this.querySelectorAll("[data-val-regex-pattern]").forEach(el => {

            if (el.hasAttribute("pattern"))
                return;

            el.setAttribute("pattern", el.getAttribute("data-val-regex-pattern"));
        });
    }

    invalidHandler = (e, validator) => {

        const validationSummary = this.validationSummary;

        // Set focus on first error field or on validation summary if it exists
        if (validationSummary === null) {

            window.setTimeout(() => {
                this.querySelector("[aria-invalid=true]")?.focus();
            }, 500);

        }
        else {
            // Update the error count in heading
            const heading = validationSummary.firstElementChild;

            if (heading != null)
                heading.innerText = heading.innerText.replace(/[0-9]/, validator.errorList.length);

            // Scroll up if needed and focus error summary
            this.scrollIntoView(true);

            window.setTimeout(() => {
                validationSummary.focus();
            }, 500);
        }

    }

    handleEnterPress = (e) => {
        if (e.key === "Enter") {
            e.preventDefault();
            const submitBtn = querySelectorLast("[type=submit]", this);
            submitBtn.click();
        }
    }

    get validationSummary() {
        return this.querySelector("[data-valmsg-summary]");
    }
}

customElements.define('validation-form', ValidationForm, { extends: 'form' });